<template>
  <div class="page">
    <div class="header">
      <img src="../../assets/images/activity/form-verification-header.png">
      <img class="header-logo" src="../../assets/images/activity/form-verification-logo.png">
    </div>
    <div class="activity-img">
      <img src="../../assets/images/activity/form-verification-icon1.png">
    </div>
    <div class="subject">
      <div>身 份 验 证</div>
    </div>
    <div class="content">
      <div class="input-row">
        <div class="icon-input icon-user"><img src="../../assets/images/activity/form-verification-user.png"></div>
        <van-field v-model="authData.loginAccount" center clearable placeholder="请填写易加网账号" @blur="viewDefault"/>
      </div>
      <div class="input-row">
        <div class="icon-input icon-pwd"><img src="../../assets/images/activity/form-verification-pwd.png"></div>
        <van-field v-model="authData.password" :type="passwordType" center clearable placeholder="请输入密码" class="pwd-cell" @blur="viewDefault"/>
        <div class="icon-input icon-right" @click="switchPwd">
          <img v-if="passwordType" src="../../assets/images/qr-pwd-hide.png" class="pwd-hide">
          <img v-else src="../../assets/images/qr-pwd-show.png" class="pwd-show">
        </div>
      </div>

      <div class="info">请仔细确认易加网账号信息后，完成身份验证</div>
      <div class="button-line" @click="submit">开 始 验 证</div>
      <div class="operate text-right">
        <span @click="goFindPwd">忘记密码</span>
        <span @click="goRegister">立即注册</span>
      </div>
      <div class="tips">
        <div>{{ `${activityTime.month}月${activityTime.day}日` }}，注册激活成功即可获得1000易加积分奖励。</div>
      </div>
    </div>

    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <div class="pop-content">
        <div class="pop-content-img">
          <img src="../../assets/images/activity/form-verification-icon2.png">
          <img v-if="showIcon" class="pop-content-right" src="../../assets/images/activity/form-verification-right.png">
        </div>
        <div class="pop-content-title">{{ verifyResult.title }}</div>
        <div class="pop-content-integral">{{ verifyResult.message }}</div>
        <div class="pop-content-btn" v-if="verifyResult.btnText">
          <div class="button-line" @click="handleJump">{{ verifyResult.btnText }}</div>
        </div>
      </div>

      <div class="pop-close" @click="popShow = false">
        <img src="../../assets/images/activity/form-verification-off.png">
      </div>
    </van-popup>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { commonUtils, cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  name: 'ActivityStreamingVerification',
  data () {
    return {
      authData: {
        loginAccount: '',
        password: ''
      },
      passwordType: 'password',
      popShow: false,
      integral: 10,
      verifyResult: {
        title: '',
        message: '',
        btnText: ''
      },
      showIcon: false,
      webSiteUrl: '',
      activityTime: {
        month: '',
        day: ''
      }
    }
  },
  mounted () {
    if (this.$route.query.activityCode) {
      this.activityTime.month = this.$route.query.activityCode.slice(11, 13)
      this.activityTime.day = this.$route.query.activityCode.slice(-2)
    }
  },
  methods: {
    submit () {
      if (!this.authData.loginAccount) {
        this.$dialog.alert({ message: '请填写您的易加网登录账号' })
        return false
      }
      if (!this.authData.password) {
        this.$dialog.alert({ message: '请填写您的易加网登录密码' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中...'
      })
      const params = {
        activityCode: this.$route.query.activityCode || '',
        loginAccount: this.authData.loginAccount,
        password: cryptoUtils.AESEncrypt(this.authData.password)
      }
      activityApi.verifyForm(params).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          userUtils.setUserLocal(response.data.resultData)
          this.webSiteUrl = commonUtils.getExtraSite() + '/#/tab/home'
          switch (response.data.resultData.action) {
            // 老客户
            case 'existingClient':
              this.verifyResult.title = '您已经是易加网忠粉啦'
              this.verifyResult.message = '参与扫码最高获100万积分！'
              this.verifyResult.btnText = '点击跳转'
              this.webSiteUrl = commonUtils.getExtraSite() + '/v2/lottery/home'
              break
            // 未激活用户
            case 'inactivated':
              this.verifyResult.title = '抱歉您还未激活'
              this.verifyResult.message = '请先进行激活后再参与活动！'
              this.verifyResult.btnText = '前往激活'
              break
            // 新用户 奖励已领取
            case 'alreadyTook':
              this.verifyResult.title = '欢迎加入易加网'
              this.verifyResult.message = '您已经领过奖励哦！'
              this.verifyResult.btnText = '跳转首页'
              break
            // 新用户 成功领取奖励
            case 'bonusTook':
              this.verifyResult.title = '欢迎加入易加网'
              this.verifyResult.message = `恭喜您获得${response.data.resultData.pointValue}欢迎积分`
              this.verifyResult.btnText = '跳转首页'
              this.showIcon = true
              break
            // 活动奖励已领取完
            case 'overLimit':
              this.verifyResult.title = '欢迎加入易加网'
              this.verifyResult.message = '非常抱歉，奖励已被领完！'
              this.verifyResult.btnText = '跳转首页'
              break
          }
          this.popShow = true
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    switchPwd () {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
    },
    goRegister () {
      // window.location.href = commonUtils.getExtraSite() + '/#/register'
      this.$router.push({ path: '/activity/live-broadcast-register', query: { activityCode: this.$route.query.activityCode || '' } })
    },
    goFindPwd () {
      window.location.href = commonUtils.getExtraSite() + '/#/forget_password'
    },
    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    handleJump () {
      window.location.href = this.webSiteUrl
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh);
  padding-top: 0;
  background: #fff;
}
.header {
  position: relative;
  img {
    width: 100%;
  }
  .header-logo {
    position: absolute;
    top: 0;
    left: 10px;
    width: 30px;
  }
}
.activity-img {
  width: 100%;
  height: 180px;
  padding-top: 30px;
  margin-bottom: 25px;
  text-align: center;
  img {
    width: 45%;
    // height: 180px;
  }
}
.subject {
  text-align: center;
  font-size: 22px;
  // line-height: 34px;
  font-weight: 700;
  color: rgb(52, 122, 127);
  margin-bottom: 30px;
  padding-bottom: 5px;
  background: url('../../assets/images/activity/form-verification-desc.png') bottom no-repeat;
  background-size: 35% auto;
}
.content {
  width: 80%;
  margin: 0 auto;
}
.input-row {
  position: relative;
  height: 40px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  .icon-input {
    position: absolute;
    z-index: 10;
    top: 10px;
  }
  .icon-user {
    left: 10px;
    width: 12px;
    height: 17px;
    img {
      width: 12px;
      height: 17px;
    }
  }
  .icon-pwd {
    left: 10px;
    width: 13px;
    height: 15px;
    img {
      width: 13px;
      height: 15px;
    }
  }
  .icon-right {
    top: 14px;
    right: 10px;
    .pwd-hide {
      width: 18px;
      height: 8px;
    }
    .pwd-show {
      width: 16px;
      height: 10px;
    }
  }
  .van-cell {
    height: 40px;
    padding-left: 36px;
    border-radius: 20px;
  }
  .pwd-cell {
    padding-right: 36px;
  }
  ::-webkit-input-placeholder{
    color: #ccc;
  }
}
.info {
  text-align: center;
  color: rgb(166, 166, 166);
}
.button-line {
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  margin: 20px 0 15px;
  background-image: linear-gradient(to right, rgba(52, 122, 127, .8), rgba(52, 122, 127, 1));
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.operate {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgb(166, 166, 166);
}
.tips {
  padding: 22px 0;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  color: rgb(52, 122, 127);
}

.van-popup {
  width: 270px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  .pop-content {
    background: url("../../assets/images/activity/form-verification-header2.png") top no-repeat;
    background-size: 100% auto;
    padding: 30px 5px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    .pop-content-img {
      position: relative;
      width: 100px;
      padding-top: 20px;
      margin: 20px auto;
      img {
        width: 100%;
        height: 100%;
      }
      .pop-content-right {
        position: absolute;
        right: 0;
        bottom: 8px;
        width: 30px;
        height: 30px;
      }
    }
    .pop-content-title {
      // font-weight: bold;
      line-height: 40px;
      font-size: 20px;
    }
    .pop-content-integral {
      line-height: 30px;
      font-size: 16px;
      color: #999;
    }
    .pop-content-btn {
      padding-top: 20px;
      .button-line {
        height: 35px;
        line-height: 35px;
        margin: 0 50px;
        font-weight: 400;
        background-color: rgba(52, 122, 127, 1);
      }
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
